import { createAsyncThunk } from '@reduxjs/toolkit';
import qs from 'query-string';
import api from 'api';
import { API_SCORECARD_SEARCH } from 'constants/api';
import { SCORECARD_STATUS_DELETED } from 'constants/scorecards';
import {
  Pagination,
  Scorecard,
  ScorecardStatus,
  ScorecardStores,
} from 'store/interfaces';
import { RootState } from 'store/index';
import { storeName as subordinateStoreName } from 'store/scorecards/subordinates/config';
import { storeName as directReportsStoreName } from 'store/scorecards/direct/config';

function getAdditionalParameters(storeName: ScorecardStores) {
  switch (storeName) {
    case subordinateStoreName:
      return { indirectSubordinates: 1 };
    case directReportsStoreName:
      return { subordinates: 1 };
    default:
      return {};
  }
}

interface FetchArg {
  store: ScorecardStores;
  reviewCycleId: number;
  page?: number;
  isArchived?: boolean;
  isDeleted?: boolean;
}

export const fetchScorecardsByCycle = createAsyncThunk<
  { list: Scorecard[]; pagination: Pagination },
  FetchArg
>(
  'scorecards/fetchByCycle',
  async (
    { store, reviewCycleId, page = 1, isArchived, isDeleted },
    thunkAPI,
  ) => {
    const {
      [store]: { filters },
    } = thunkAPI.getState() as RootState;

    const isArchivedParam = isArchived ? { archive: true } : {};
    const isDeletedParam = isDeleted
      ? { scorecardStatuses: SCORECARD_STATUS_DELETED as ScorecardStatus }
      : {};

    const queryParams = {
      ...getAdditionalParameters(store),
      ...filters,
      ...isArchivedParam,
      ...isDeletedParam,
      reviewCycleIds: reviewCycleId,
      viewMode: null,
      page,
      limit: 100,
    };

    return api.axios
      .get(
        `${API_SCORECARD_SEARCH}?${qs.stringify(queryParams, {
          skipNull: true,
          skipEmptyString: true,
        })}`,
      )
      .then((res) => res.data)
      .catch((e) => thunkAPI.rejectWithValue(e.response?.data));
  },
);
